import React, {FC, useState} from 'react';
import {useDispatch} from 'react-redux';
import 'react-datetime/css/react-datetime.css';
import TermsForImport from '../terms/terms-for-import';
import TermsImported from '../terms/terms-imported';
import TermsForceImport from '../terms/terms-force-import';
import useEffectOnce from "~/hooks/use-effect-once.ts";
import {actions} from "~/state/reducers/term-reducer.ts";

export const TermsPage: FC = () => {
    const dispatch = useDispatch();
    const [isNewTermsModalOpen, setIsNewTermsModalOpen] = useState(true);

    useEffectOnce(() => {
        dispatch(actions.loadTerms())
    });

    const toggleModalOpen = () => {
        setIsNewTermsModalOpen((prevState) => !prevState);
    };

    const forceModalOpen = () => {
        setIsNewTermsModalOpen(() => true);
    };

    return (
        <React.Fragment>
            <h2 className="mb-3 h4">UCC Term Management</h2>
            <h3 className="mb-3 h5">Import Terms</h3>
            <TermsForceImport forceModalOpen={forceModalOpen}/>

            <TermsForImport
                isNewTermsModalOpen={isNewTermsModalOpen}
                toggleModalOpen={toggleModalOpen}
            />
            <TermsImported/>
        </React.Fragment>
    );
}

export default TermsPage;
